// packages/game/src/scenes/craps-tutorial/DiceOverlayScene.ts
//
// Mirror of CrapsDiceOverlayScene for the tutorial: hosts the two visual
// Dice above CrapsTutorialScene + CrapsTutorialUIScene so they render on
// top of the highlight overlay, narration cards, and help mode.
import Phaser from 'phaser';
import { Dice } from '../../objects/Dice.js';

export class CrapsTutorialDiceOverlayScene extends Phaser.Scene {
  dice1: Dice | undefined;
  dice2: Dice | undefined;

  constructor() {
    super('CrapsTutorialDiceOverlayScene');
  }

  create() {
    this.cameras.main.setBackgroundColor('rgba(0,0,0,0)');
  }

  setupDice(opts: {
    home: { x: number; y: number; halfSep: number };
    diceSize: number;
  }): { dice1: Dice; dice2: Dice } {
    this.dice1?.destroy();
    this.dice2?.destroy();
    this.dice1 = new Dice(this, opts.home.x - opts.home.halfSep, opts.home.y, opts.diceSize);
    this.dice2 = new Dice(this, opts.home.x + opts.home.halfSep, opts.home.y, opts.diceSize);
    return { dice1: this.dice1, dice2: this.dice2 };
  }
}
